import { render, staticRenderFns } from "./SeparatorRed.vue?vue&type=template&id=be5e5fcc&"
import script from "./SeparatorRed.vue?vue&type=script&lang=js&"
export * from "./SeparatorRed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports